/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

const ImageModalPopup = ({ imageUrl, alt }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const src = imageUrl;

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Image
        src={src}
        alt={alt || 'Chart image'}
        className="chart-image"
        style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto' }}
        onClick={handleImageClick}
        crossOrigin="anonymous"
      />

      {/* Modal Overlay */}
      {isModalOpen && (
        <div
          className="modal-backdrop"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
          onClick={handleCloseModal}
        >
          <div
            style={{ position: 'relative' }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                width: 36,
                height: 36,
                borderRadius: '50%',
                border: 'none',
                background: 'rgba(255,255,255,0.95)',
                fontSize: 22,
                fontWeight: 600,
                lineHeight: '36px',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
              }}
              title="Close"
            >
              ×
            </button>
            <img
              src={src}
              alt={alt || 'Chart image enlarged'}
              crossOrigin="anonymous"
              style={{
                maxWidth: 'calc(100vw - 40px)',
                maxHeight: 'calc(100vh - 40px)',
                boxShadow: '0 0 15px rgba(0,0,0,0.4)',
                background: 'white',
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

ImageModalPopup.defaultProps = {
  alt: 'Chart image',
};

ImageModalPopup.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default ImageModalPopup;
